export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'يوجد نوع من المؤشرات بنفس الاسم'
    }
  }
}
